import React, { useEffect } from "react";
import { observer } from "mobx-react";
import NurseAndCareGiverDocViewerList from "../../Agency/Pages/DocViewerList/NurseAndCareGiverDocViewerList";
import CareGiverStore from "../../Store/CareGiverStore";
import PageTitle from "../../Agency/PageTitle";
import Icon from "../../components/Icons/Icon";

const DocApplicationAndHiring = () => {
  useEffect(() => {
    CareGiverStore.getEmployeeDocs();
  }, []);

  return (
    <div>
      <div className="pageHeaderContainer">
        <PageTitle
          icon={<Icon iconName="menu" />}
          headerTitle="Document"
          subHeaderTitle="  Document/Application & Hiring"
        />
      </div>
      <NurseAndCareGiverDocViewerList applicationResumeAndHireResultSet="applicationResumeAndHireResultSet" />
    </div>
  );
};

export default observer(DocApplicationAndHiring);
